import useIsGameCurrencyChangeEnabled from '~/client/hooks/feature/inGameCurrency/useIsGameCurrencyChangeEnabled';
import isSsr from '~/shared/utils/isSsr';
import { useOtherFreebetRewardsQuery } from './OtherFreebetRewardsQuery.generated';
import useForfeitFSReward from './useForfeitFSReward';
import useHandleCurrencyChange from './useHandleCurrencyChange';
import useGameContext from '../../context/Game/useGameContext';

type Args = {
  inGameCurrency?: Unit;
  walletCurrency?: Unit;
};

const useOtherFreebetRewardNotification = ({
  inGameCurrency,
  walletCurrency = 'mBTC',
}: Args) => {
  const { game } = useGameContext();
  const isGameCurrencyChangeEnabled = useIsGameCurrencyChangeEnabled();

  const { data } = useOtherFreebetRewardsQuery({
    skip: !game?.id || isSsr(),
    variables: {
      currency: walletCurrency,
      game: game?.id ?? '',
      inGameCurrency: isGameCurrencyChangeEnabled ? inGameCurrency : undefined,
    },
    fetchPolicy: 'no-cache',
  });

  const reward = data?.rewards?.myOtherFreebetRewards?.edges?.[0]?.node;

  const { handleCurrencyChange } = useHandleCurrencyChange(reward);

  const { handleForfeit } = useForfeitFSReward({
    currency: walletCurrency,
    game: game?.id ?? '',
    inGameCurrency,
    id: reward?.id ?? '',
  });

  return { reward, handleCurrencyChange, handleForfeit };
};

export default useOtherFreebetRewardNotification;
